// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CrmRepoManager from "../../../../../to-be-migrated/domain/repo/CrmRepoManager.bs.js";
import * as UnsuspendModal from "./modals/UnsuspendModal.bs.js";
import * as SuspensionModal from "./modals/SuspensionModal.bs.js";
import * as TerminationModal from "./modals/TerminationModal.bs.js";
import * as DriverRecordsStore from "./DriverRecordsStore.bs.js";
import * as ReactivateDriverModal from "./modals/ReactivateDriverModal.bs.js";
import * as LoaderComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/loader/LoaderComponent.bs.js";

var SuspensionModalLoaderConfig = {};

var TerminationModalLoaderConfig = {};

var TerminationModalLoaderComponent = LoaderComponent$Catalyst.LoaderComponentWithoutRefresh(TerminationModalLoaderConfig);

var SuspensionLoaderComponent = LoaderComponent$Catalyst.LoaderComponentWithoutRefresh(SuspensionModalLoaderConfig);

function getModal(modalState, toggleModal, dataLoader, openSnackbar, country) {
  if (typeof modalState === "number") {
    return null;
  }
  switch (modalState.TAG | 0) {
    case /* Suspend */0 :
        var msisdn = modalState._0;
        return React.createElement(SuspensionLoaderComponent.make, {
                    fetchData: (function (param) {
                        var RepoInstance = CrmRepoManager.getSuspensionRepo(undefined);
                        return Curry._1(RepoInstance.fetchSuspensionReasons, country);
                      }),
                    loadingView: (function (param) {
                        return null;
                      }),
                    renderView: (function (suspensionReasons) {
                        return React.createElement("div", undefined, React.createElement(SuspensionModal.make, {
                                        suspensionReasons: suspensionReasons,
                                        refreshView: (function (param) {
                                            return DriverRecordsStore.refreshSuspensionInfo(msisdn, dataLoader, country);
                                          }),
                                        onToggle: toggleModal,
                                        msisdn: msisdn,
                                        openSnackbar: openSnackbar
                                      }));
                      })
                  });
    case /* Unsuspend */1 :
        var msisdn$1 = modalState._0;
        return React.createElement(UnsuspendModal.make, {
                    msisdn: msisdn$1,
                    onToggle: toggleModal,
                    openSnackbar: openSnackbar,
                    refreshView: (function (param) {
                        return DriverRecordsStore.refreshSuspensionInfo(msisdn$1, dataLoader, country);
                      })
                  });
    case /* Termination */2 :
        var msisdn$2 = modalState._0;
        return React.createElement(TerminationModalLoaderComponent.make, {
                    fetchData: (function (param) {
                        var RepoInstance = CrmRepoManager.getTerminationRepo(undefined);
                        return Curry._1(RepoInstance.fetchTerminationReasons, country);
                      }),
                    loadingView: (function (param) {
                        return null;
                      }),
                    renderView: (function (terminationReasons) {
                        return React.createElement("div", undefined, React.createElement(TerminationModal.make, {
                                        terminationReasons: terminationReasons,
                                        refreshView: (function (param) {
                                            return DriverRecordsStore.refreshTerminationData(msisdn$2, dataLoader, country);
                                          }),
                                        onToggle: toggleModal,
                                        msisdn: msisdn$2
                                      }));
                      })
                  });
    case /* Reactivate */3 :
        var msisdn$3 = modalState._0;
        return React.createElement(ReactivateDriverModal.make, {
                    refreshView: (function (param) {
                        return DriverRecordsStore.refreshTerminationData(msisdn$3, dataLoader, country);
                      }),
                    onToggle: toggleModal,
                    msisdn: msisdn$3
                  });
    
  }
}

function getModalManager(modalState, toggleModal, dataLoader, openSnackbar, country) {
  if (modalState !== undefined) {
    return getModal(modalState, toggleModal, dataLoader, openSnackbar, country);
  } else {
    return null;
  }
}

export {
  SuspensionModalLoaderConfig ,
  TerminationModalLoaderConfig ,
  TerminationModalLoaderComponent ,
  SuspensionLoaderComponent ,
  getModal ,
  getModalManager ,
  
}
/* TerminationModalLoaderComponent Not a pure module */
